import { HTMLVisualElement } from './basler-components.es852.js';
import { ObjectVisualElement } from './basler-components.es853.js';
import { visualElementStore } from './basler-components.es833.js';
import { SVGVisualElement } from './basler-components.es854.js';
import { isSVGElement } from './basler-components.es784.js';
import { isSVGSVGElement } from './basler-components.es786.js';

function createDOMVisualElement(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {},
            },
            latestValues: {},
        },
    };
    const node = isSVGElement(element) && !isSVGSVGElement(element)
        ? new SVGVisualElement(options)
        : new HTMLVisualElement(options);
    node.mount(element);
    visualElementStore.set(element, node);
}
function createObjectVisualElement(subject) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {},
            },
            latestValues: {},
        },
    };
    const node = new ObjectVisualElement(options);
    node.mount(subject);
    visualElementStore.set(subject, node);
}

export { createDOMVisualElement, createObjectVisualElement };
